import React, { useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import styled from 'styled-components';

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginImageValidateSize,
);

const DropZoneSound = (props) => {
  const [files, setFiles] = useState(null);

  const { setFile, setPreview } = props;
  // console.log(props);
  // console.log(props.setFile);
  // console.log(!props.setFile);

  /** 업로드할 이미지 파일 보내기 */
  const onupdatefiles = (fileData) => {
    // console.log(fileData);
    if (fileData.length === 0) {
      return;
    } else {
      setFile(fileData[0].file);
      // setPreview(false);
    }
  };

  return (
    <Wrap>
      <FilePond
        acceptedFileTypes={[
          // 'audio/x-wav',
          // 'audio/s-wav',
          // 'audio/wav',
          'audio/mpeg',
          'audio/mp3',
          'audio/x-mp3',
          'audio/x-mpeg',
          // 'audio/x-ms-wma',
        ]}
        // allowFileTypeValidation={true}
        file={files}
        allowMultiple={false}
        onupdatefiles={onupdatefiles}
        // onupdatefiles={props.setFile(files)}
        labelIdle='mp3 파일을 끌어놓거나 클릭하여 업로드 해주세요.'
      />
    </Wrap>
  );
};

export default DropZoneSound;
const Wrap = styled.div`
  .filepond--root {
    width: 100%;
  }
`;
